var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSlash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BFC2C5",
  d: "M2.288 12.168a.83.83 0 0 1-.336.416.83.83 0 0 1-.448.136h-.6L5.712.744a.86.86 0 0 1 .296-.392.77.77 0 0 1 .456-.136h.6z"
})));
export { SvgSlash as ReactComponent };
export default __webpack_public_path__ + "static/media/slash.c2f2460b.svg";